import type { FormattedTextParams, FormattedTextReturn } from '../types';
import { renderRichText } from '@storyblok/js';

export default function (params: FormattedTextParams): FormattedTextReturn {
  const { name, _editable, _uid, component, link, text, fontSize, fontWeight, textAlign } = params;
  return {
    module: 'SFormattedText',
    name,
    component,
    _editable,
    _uid,
    link,
    text: renderRichText(text),
    fontSize,
    fontWeight,
    textAlign
  };
}
